import Vue from 'vue';

import LoginForm from './components/pages/LoginForm.vue'
import LinkRequestForm from './components/pages/LinkRequestForm.vue'
import ResetForm from './components/pages/ResetForm.vue'
import TwoFactorForm from './components/pages/TwoFactorForm.vue'
import RecoveryCodeForm from './components/pages/RecoveryCodeForm.vue'

Vue.component('login-form', LoginForm);
Vue.component('link-request-form', LinkRequestForm);
Vue.component('reset-form', ResetForm);
Vue.component('two-factor-form', TwoFactorForm);
Vue.component('recovery-code-form', RecoveryCodeForm);